import { createContext } from 'react';

/** Inline-edit draft shared by the event detail body and its decision footer. */
export const EventDraftContext = createContext(null);
